import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useBreadcrumbs } from '../hooks/useBreadcrumbs';

const Breadcrumbs: React.FC = () => {
  const breadcrumbs = useBreadcrumbs();

  if (breadcrumbs.length === 0) return null;

  return (
    <nav className="flex items-center gap-2 text-sm mb-4">
      {breadcrumbs.map((crumb, index) => (
        <React.Fragment key={index}>
          {index > 0 && <ChevronRight className="h-4 w-4 text-[rgb(var(--muted))] dark:text-gray-500" />}
          {crumb.href && index < breadcrumbs.length - 1 ? (
            <Link 
              to={crumb.href}
              className="text-gray-500 dark:text-[rgb(var(--muted))] hover:text-gray-700 dark:hover:text-[rgb(var(--muted))] transition-colors"
            >
              {crumb.label}
            </Link>
          ) : (
            <span className={index === breadcrumbs.length - 1 ? "text-gray-900 dark:text-[rgb(var(--fg))] font-medium" : "text-gray-500 dark:text-[rgb(var(--muted))]"}>
              {crumb.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumbs;

